<template>
  <course-type-select-modal
    :open="state.visible"
    :course-title="state.courseTitle"
    :default-type="state.defaultType"
    :type-list="state.typeList"
    @confirm="confirmCourseTypeSelect"
    @cancel="cancelCourseTypeSelect"
  />
</template>

<script>
import CourseTypeSelectModal from '@/components/CourseTypeSelectModal.vue'
import {
  getCourseTypeSelectState,
  confirmCourseTypeSelect,
  cancelCourseTypeSelect
} from '@/utils/courseDetailNav'

export default {
  name: 'CourseTypeSelectHost',
  components: { CourseTypeSelectModal },
  setup () {
    return {
      state: getCourseTypeSelectState(),
      confirmCourseTypeSelect,
      cancelCourseTypeSelect
    }
  }
}
</script>
